import { inject } from "@angular/core";
import { tapResponse } from "@ngrx/operators";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { MaintenanceModeResponse, MaintenanceModeService } from "@src/app/shared/services";
import { pipe, switchMap } from "rxjs";

export type MaintenanceModeState = {
    maintenanceMode: MaintenanceModeResponse;
}

const initialState: MaintenanceModeState = {
    maintenanceMode: new MaintenanceModeResponse(false)
}

export type MaintenanceModeStore = InstanceType<typeof MaintenanceModeStore>;

export const MaintenanceModeStore = signalStore(
    withState(initialState),
    withMethods((
        store,
        maintenanceModeService = inject(MaintenanceModeService)
    ) => ({
        getMaintenanceMode: rxMethod<void>(
            pipe(
                switchMap(() => {
                    return maintenanceModeService.fetchMaintenanceMode().pipe(
                        tapResponse({
                            next: (response) => {
                                patchState(store, () => ({
                                    maintenanceMode: {
                                        isOn: response.isOn,
                                        startTime: response.startTime,
                                        endTime: response.endTime,
                                        customMessage: response.customMessage
                                    }
                                }));
                            },
                            error: () => console.error
                        })
                    )
                })
            )
        )
    }))
);